import { IFaqs } from './../../api/models/faq.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class FaqService {
  constructor(public http: HttpClient) {}

  public getFaqs(): Observable<IFaqs> {
    return this.http.get('assets/faq/faq.json').pipe(map((response: IFaqs) => response));
  }
}
